import { transition } from "@codesandbox/states";
import type { ApiEvent } from "environment-interface/api";
import type { VisibilityNumber } from "features/editor/sandboxUtils";

export type State =
  | { state: "READY" }
  | { state: "CREATE_FORK_ERROR"; message: string; workspaceId: string | null }
  | {
      state: "FORKING";
      workspaceId: string | null;
      collectionId?: string;
      privacy: VisibilityNumber;
    };

export type PublicAction =
  | {
      type: "CREATE_FORK";
      workspaceId: string;
      collectionId?: string;
      privacy: VisibilityNumber;
    }
  | { type: "DISMISS_ERROR" };

export type PrivateAction = ApiEvent;

export type Action = PublicAction | PrivateAction;

export const reducer = (prevState: State, action: Action) =>
  transition(prevState, action, {
    READY: {
      CREATE_FORK: (_, { workspaceId, collectionId, privacy }) => ({
        state: "FORKING",
        workspaceId,
        collectionId,
        privacy,
      }),
    },
    FORKING: {
      "API:FORK_SANDBOX_SUCCESS": () => ({
        state: "READY",
      }),
      "API:FORK_SANDBOX_ERROR": (_, { message, workspaceId }) => ({
        state: "CREATE_FORK_ERROR",
        message,
        workspaceId,
      }),
    },
    CREATE_FORK_ERROR: {
      DISMISS_ERROR: () => ({
        state: "READY",
      }),
      CREATE_FORK: (_, { workspaceId, collectionId, privacy }) => ({
        state: "FORKING",
        workspaceId,
        collectionId,
        privacy,
      }),
    },
  });
